import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import styled from 'styled-components';
import sortBy from 'lodash.sortby';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import TextField from 'material-ui/TextField';
import FlatButton from 'material-ui/FlatButton';
import ActionSearch from 'material-ui/svg-icons/action/search';
import NavigationArrowBack from 'material-ui/svg-icons/navigation/arrow-back';

import { getSingleUser } from '../../actions/userActions';
import { getUserOrders } from '../../actions/orderActions';

import {
  Header,
  FormTitle
} from '../Styles/index';
import OrdersTable from './UserOrderTable';
import LoadingState from '../Loading';

const TableContainer = styled.div`
  
`
const Container = styled.div`
  max-width: 1440px;
  margin: 0 auto;
  padding: 32px 16px;
`

class UserOrders extends Component {
  state = {
    orders: [],
    orderBy: 'no',
    orderByItems: ['no', 'date', 'amount'],
    showTable: true,
    user: {},
    searchQuery: '',
  }

  _orderBy(value){
    switch (value) {
      case 'date':
        return sortBy(this.state.orders, value =>  new Date(value.date)).reverse();
      case 'amount': 
        return sortBy(this.state.orders, order => {
          let amount = 0;
          for (const key in order.products) {
            amount += order.products[key];
          }
          return amount
        });
      default:
        return sortBy(this.state.orders, [value]);
    }
  }

  _handleChange = (event, index, value) => {
    const orders = this._orderBy(value);
    console.log(orders)
    this.setState({
      orderBy: value,
      orders
    });
  }

  _goToEditPage = (code) => {
    this.props.history.push(`/orders/edit?order=${code}`);
  }

  async componentWillMount() {
    await this.props.getSingleUser({ username: this.props.match.params.id});

    await this.props.getUserOrders({ userKey: this.props.user.user.key });
    console.log(this.props.orders)
    
    this.setState({
      orders: this.props.orders.data,
      user: this.props.user.user
    });
  }

  componentDidMount() {
    console.log(this.props)
    // const userKey = this.props.match.params.id
    
  }
  render() {
    const tableHeader = ['No', 'Date', 'Amount', 'Status', 'Notes', ''];
    return (
      <Container>
        <div>
            <FormTitle style={{ opacity: this.props.orders.loading ? 0 : 1 }}>Orders for { this.state.user.email } !</FormTitle>
          </div>
        <Header>
          <div style={{flex: 1, height: '74px', paddingRight: '24px'}}>
            {!this.state.showTable &&
              <FlatButton
                style={{minWidth: '48px'}}
                type="submit"
                label="Back"
                onTouchTap={this._handleSearchBack}
                icon={<NavigationArrowBack />}
              />
            }
            {this.state.showTable && <SelectField
              floatingLabelText="Sort By"
              value={this.state.orderBy}
              onChange={this._handleChange}
            >
              {this.state.orderByItems.map((item, index) => <MenuItem key={index} value={item} primaryText={item}/>)}
            </SelectField>}
          </div>
          <div>
            <form onSubmit={this._handleSearchSubmit}>
              <TextField
                name="searchQuery"
                id="searchQuery"
                onChange={this._handleSearchChange}
                value={this.state.searchQuery}
                hintText="Search orders"
              />
              <FlatButton
                style={{minWidth: '48px'}}
                type="submit"
                icon={<ActionSearch />}
              />
            </form>
          </div>
        </Header>
        {this.props.orders.loading 
          ? <LoadingState/>
          : <div>
              { this.state.showTable &&
                <div>
                  <TableContainer>
                    { !this.props.orders.loading && <OrdersTable  
                      refreshPage={this._refreshPage}  
                      headers={tableHeader} 
                      editHandler={this._goToEditPage} 
                      tableData={this.state.orders} 
                      height={this.props.orders.data.length*48}
                    />}
                  </TableContainer>
                </div>
              }
              { !this.state.showTable &&
                <div>
                  <div>Search Page</div>
                  {/* <UserSearchResult refreshPage={this._refreshPage} goToEditPage={this._goToEditPage} query={this.state.searchQuery} user={this.props.user}/> */}
                </div>
              }
            </div>
          }
      </Container>
    );
  }
}

const mapStateToProps = state => ({ user: state.users.userToEdit, orders: state.order.userOrders });
const mapDispatchToProps = { getSingleUser, getUserOrders };
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UserOrders));



// WEBPACK FOOTER //
// ./src/components/Users/UserOrders.js